import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Administration } from '../_models/administration';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  get() {
    return this.http.get<Administration>(`${environment.apiUrl}/Settings`, { headers: this.authService.headers });
  }

  update(settings: Administration) {
    return this.http.put<Administration>(`${environment.apiUrl}/Settings/${settings?.settingId}`, settings, { headers: this.authService.headers });
  }
}
